import { render, staticRenderFns } from "./indexMenu.vue?vue&type=template&id=bf472c1c&scoped=true"
import script from "./indexMenu.vue?vue&type=script&lang=js"
export * from "./indexMenu.vue?vue&type=script&lang=js"
import style0 from "./indexMenu.vue?vue&type=style&index=0&id=bf472c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf472c1c",
  null
  
)

export default component.exports